// src/pages/About.jsx
import React from "react";
import "./About.css";

import aditImg from "../assets/adit.png";
import glebImg from "../assets/gleb.png";
import bertImg from "../assets/bert.png";

const team = [
  { id: "bert", name: "Albert Cheng", role: "Co-Founder", photo: bertImg, linkedin: "#" },
  { id: "gleb", name: "Gleb Hulting", role: "Co-Founder", photo: glebImg, linkedin: "#" },
  { id: "adit", name: "Aditya Sabharwal", role: "Co-Founder", photo: aditImg, linkedin: "#" },
];

export default function About() {
  return (
    <main className="about-page">
      {/* Shift wrapper (moves EVERYTHING) */}
      <div className="about-shift">
        {/* Decorative lines overlay */}
        <div className="about-lines" aria-hidden="true">
          <span className="about-line v v1" />
          <span className="about-line v v2" />
          <span className="about-line h h1" />
          <span className="about-line h h2" />
        </div>

        {/* Mission / Thesis-like intro */}
        <section className="about-hero">
          <div className="about-shell">
            <div className="about-hero-copy">
              <h1 className="about-title">
                Public meetings should be{" "}
                <span className="about-title-accent">understandable</span>.
              </h1>

              <p className="about-subtitle">
                BoardWatch exists to restore clarity in public decision-making. We turn long,
                messy meetings into structured, source-backed narratives so communities can follow what
                happened and why, without losing hours of their lives.
              </p>

              <div className="about-mission">
                <h2 className="about-section-kicker">Our mission</h2>
                <p className="about-mission-text">
                  Make governance legible: transform hours of public meeting video into concise,
                  evidence-linked summaries that people can search, share, and rely on.
                </p>
              </div>

              <div className="about-principles">
                <div className="principle">
                  <div className="principle-title">Clarity</div>
                  <p className="principle-text">
                    Information is only useful if it is readable. Our job is to distill noise into a coherent story.
                  </p>
                </div>

                <div className="principle">
                  <div className="principle-title">Receipts</div>
                  <p className="principle-text">
                    Every summary should be tied to the record. Citations are not a nice-to-have, they are the foundation.
                  </p>
                </div>

                <div className="principle">
                  <div className="principle-title">Access</div>
                  <p className="principle-text">
                    Transparency should not require expertise or free time. We build for the working parent and the busy staffer.
                  </p>
                </div>
              </div>

              <div className="about-story">
                <h2 className="about-story-title">Why we built it</h2>
                <p>
                  The people most affected by public decisions are often the least able to track them.
                  Meetings are long, agendas are dense, and important moments are buried in hours of footage.
                </p>
                <p>
                  BoardWatch makes the public record usable by converting it into structured updates that preserve context
                  and make it easy to verify what was said.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="about-team">
          <div className="about-shell">
            <div className="about-team-header">
              <h2 className="about-team-title">Meet The Team</h2>
              <div className="about-team-underline" />
              <p className="about-team-sub">
                We are building BoardWatch to make public meetings easier to understand and act on.
              </p>
            </div>

            <div className="about-team-grid">
              {team.map((m) => (
                <article className="team-card" key={m.id}>
                  <div className="team-photo-wrap">
                    <img className="team-photo" src={m.photo} alt={m.name} />
                  </div>

                  <div className="team-meta">
                    <div className="team-name">{m.name}</div>
                    <div className="team-role">{m.role}</div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}